// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"40f18485","116":"c8443074","200":"c59109d5","213":"afaf89b8","235":"b8043495","239":"da93795d","363":"24aa42e1","380":"10e57469","396":"6258f2c1","453":"d94261f7","455":"1e09c43e","468":"ffa7a831","813":"4074338e","834":"f0545cdd","971":"9d955fab"}[chunkId] + ".chunk.js";
};